import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import ApplicationRouter from "./router";

const App = () => {
  return (
    <Router>
      <ApplicationRouter />
    </Router>
  );
};

export default App;
